import React from "react";
import Header from "../components/header/header";
import Doc from "../../assets/img/demo-doc-image.png";
import Footer from "../components/footer/footer";
import "./whoAreTheDoctors.scss";

const BOOKING_URL =
    "https://consumer.scheduling.athena.io/?locationId=20729-1&practitionerId=20729-1";

const WhoAreTheDoctors = () => {
    return (
        <div className="who-are-the-doc">
            <div className="who-are-the-doc-header-about-doc">
                <Header />
            </div>

            <section className="who-hero">
                <div className="container">
                    <h2>Meet the doctors behind your care</h2>
                    <p>
                        Licensed psychiatrists and therapists, dedicated to your long-term
                        mental wellness.
                    </p>
                </div>
            </section>

            <section className="who-section who-quality">
                <div className="container">
                    <div className="who-quality-grid">
                        <div className="who-quality-img">
                            <img src={Doc} alt="A VirtualPsych psychiatrist" />
                        </div>
                        <div className="who-quality-text">
                            <h2>Quality Care. The Time &amp; Attention You Deserve.</h2>
                            <p>
                                VirtualPsych provides intake assessments if you&apos;re not quite sure
                                what type of telepsych care you need. Follow-up appointments are
                                tailored to your specific concerns, and your input helps shape your
                                treatment approach.
                            </p>
                            <p>
                                Appointments using phone or video chat afford you the privacy you
                                want without an in-office visit. Being in the comfort of your home
                                can prove valuable in discussing your mental health concerns
                                without the feeling of being rushed.
                            </p>
                            <p>
                                VirtualPsych is a completely new approach to mental health care.
                                Our doctors take the time to give you the attention you deserve
                                &mdash; comprehensive, personalized care from anywhere, on any
                                device.
                            </p>
                        </div>
                    </div>
                </div>
            </section>

            <section className="who-section who-features">
                <div className="container">
                    <header className="who-section-head">
                        <h2>Virtual Psychiatric Care</h2>
                        <p>Personalized care for your long-term behavioral health.</p>
                    </header>
                    <div className="row g-4">
                        <div className="col-12 col-md-4">
                            <article className="who-feature-card">
                                <span className="who-feature-icon" aria-hidden="true">
                                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                                        <rect x="3" y="5" width="18" height="16" rx="2" />
                                        <path d="M16 3v4M8 3v4M3 10h18" />
                                    </svg>
                                </span>
                                <h3>VirtualPsych books fast</h3>
                                <p>
                                    Appointments are available daily &mdash; you can typically see
                                    a physician in less than a few days.
                                </p>
                            </article>
                        </div>
                        <div className="col-12 col-md-4">
                            <article className="who-feature-card">
                                <span className="who-feature-icon" aria-hidden="true">
                                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                                        <rect x="3" y="6" width="14" height="12" rx="2" />
                                        <path d="m17 10 4-3v10l-4-3" />
                                    </svg>
                                </span>
                                <h3>100% Virtual Appointments</h3>
                                <p>
                                    Phone or video chat gives you the privacy you want, without the
                                    need for an in-office visit.
                                </p>
                            </article>
                        </div>
                        <div className="col-12 col-md-4">
                            <article className="who-feature-card">
                                <span className="who-feature-icon" aria-hidden="true">
                                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                                        <path d="M21 12a8 8 0 0 1-11.6 7.1L4 21l1.9-5.4A8 8 0 1 1 21 12z" />
                                    </svg>
                                </span>
                                <h3>VirtualPsych listens</h3>
                                <p>
                                    Our providers listen &mdash; your concerns and input help guide
                                    you toward better mental health.
                                </p>
                            </article>
                        </div>
                    </div>
                </div>
            </section>

            <section className="who-booking-banner">
                <div className="container">
                    <div className="who-booking-card">
                        <span className="who-booking-eyebrow">New appointments available</span>
                        <h2>Book your appointment today</h2>
                        <p>
                            Most patients can see a provider within a few days. Pick a time that
                            works for you and get the care you deserve.
                        </p>
                        <a
                            href={BOOKING_URL}
                            className="who-booking-cta"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            Book an Appointment
                            <svg
                                className="who-booking-cta-arrow"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                aria-hidden="true"
                            >
                                <path d="M5 12h14M13 5l7 7-7 7" />
                            </svg>
                        </a>
                    </div>
                </div>
            </section>

            <Footer />
        </div>
    );
};

export default WhoAreTheDoctors;
